<template>
  <v-toolbar class="header" tile color="white" elevation="0">
    <slot name="drawer"></slot>
    <v-toolbar-title v-if="$vuetify.breakpoint.smAndUp" style="color: #606060">
      <a @click="goToRouteByName('Home')">
        <img class="mt-2" style="max-height: 45px; max-width: 140px;" :src="logo"/>
      </a>
    </v-toolbar-title>
    <v-text-field class="mx-xl-12 mx-lg-12 mx-md-8 mx-sm-4 mx-1"
      v-model="searchValue"
      placeholder="Buscar..."
      rounded
      filled
      dense
      light
      hide-details
      @keyup.native.enter="performSearch">
      <template v-slot:prepend-inner>
        <v-icon>search</v-icon>
      </template>
    </v-text-field>
    <v-btn icon color="#606060" v-if="$vuetify.breakpoint.mdAndUp && !isAuthenticated" @click="goToRouteByName('Login')">
      <v-icon>account_circle</v-icon>
    </v-btn>

    <v-btn icon color="#606060" v-if="$vuetify.breakpoint.mdAndUp && !isAuthenticated" @click="goToRouteByName('Register')">
      <v-icon>person_add</v-icon>
    </v-btn>

    <v-btn icon color="#606060" @click="goToRouteByName('Shopping-cart')">
      <v-badge v-if="totalShoppingCart"
        color="red"
        :content="totalShoppingCart"
        overlap>
        <v-icon>shopping_cart</v-icon>
      </v-badge>
      <v-icon v-else>shopping_cart</v-icon>
    </v-btn>

    <v-menu offset-y left :close-on-content-click="false" v-if="isAuthenticated" ref="menu">
      <template v-slot:activator="{ on }">
        <v-btn icon color="#606060" v-on="on">
          <v-badge v-if="getUnreadNotifications"
            color="red"
            :content="getUnreadNotifications"
            overlap>
            <v-icon>notifications</v-icon>
          </v-badge>
          <v-icon v-else>notifications</v-icon>
        </v-btn>
      </template>

      <v-card class="notifications-container">
        <v-list two-line class="py-0 text-left" v-if="showNofFound">
          <template>
            <v-list-item>
              <template>
                <v-list-item-avatar>
                  <v-icon class="blue white--text">notifications_off</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Notificaciones</v-list-item-title>
                  <v-list-item-subtitle class="description">No se encontraron notificaciones</v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-list-item>
          </template>
        </v-list>
        <v-list two-line class="py-0 text-left" v-else>
          <div v-for="notification in notifications.notifications" :key="notification.notification_id">
            <notification-item :notification="notification" :key="notification.notification_id" @closeMenu="closeMenu"></notification-item>
            <v-divider></v-divider>
          </div>
          <template v-if="notifications.next">
            <v-list-item class="more">
              <template>
                <div class="view-more">
                  <v-progress-circular class="progress" indeterminate size="24" width="3" v-if="loadingMoreNotifications"></v-progress-circular>
                  <v-btn text class="text-none load-more" small @click="loadMoreNotifications" v-else>Cargar Mas</v-btn>
                </div>
              </template>
            </v-list-item>
          </template>
        </v-list>
      </v-card>
    </v-menu>

    <v-btn icon color="#606060" v-if="$vuetify.breakpoint.mdAndUp && isAuthenticated" @click="signOff">
      <v-icon>power_settings_new</v-icon>
    </v-btn>
  </v-toolbar>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import navigationMixin from '@/mixins/navigation'
import NotificationItem from '@/components/Notification/NotificationItem'
import logoCL from '@/assets/logo.png'

export default {
  name: 'Toolbar',
  mixins: [navigationMixin],
  components: {
    NotificationItem
  },
  data () {
    return {
      searchValue: null,
      logo: logoCL,
      loadingMoreNotifications: false
    }
  },
  computed: {
    ...mapState('auth', ['isAuthenticated']),
    ...mapState('product', ['search']),
    ...mapState('notification', ['notifications']),
    ...mapGetters('cart', ['totalShoppingCart']),
    ...mapGetters('notification', ['getUnreadNotifications']),
    showNofFound () {
      return !this.notifications
    }
  },
  methods: {
    ...mapMutations('cart', ['cleanShoppingCart']),
    ...mapActions('auth', ['logout']),
    ...mapActions('notification', ['getNotifications']),
    ...mapActions('websocket', ['closeConnection']),
    ...mapActions('notification', ['getNotifications', 'getMoreNotifications']),
    async signOff () {
      this.cleanShoppingCart()
      await this.closeConnection()
      await this.logout()
      this.goToRouteByName('Login')
    },
    performSearch () {
      if (this.searchValue.trim() === '') {
        return
      }

      // eslint-disable-next-line
      fbq('track', 'Search')
      this.goToRouteByName('Search', { search: this.searchValue })
    },
    async loadMoreNotifications () {
      this.loadingMoreNotifications = true
      await this.getMoreNotifications(this.notifications.next)
      this.loadingMoreNotifications = false
    },
    closeMenu () {
      this.$refs.menu.isActive = false
    }
  },
  mounted () {
    this.searchValue = this.search

    if (this.isAuthenticated) {
      this.getNotifications()
    }
  }
}
</script>

<style scoped>
.container {
  padding: 0px;
}
.notifications-container {
  max-width: 22.125rem;
  max-height: 31.938rem;
}
.more {
  justify-content: center;
  min-height: 48px;
}
.header {
  border-bottom: 1px solid;
  border-top: 1px solid;
  border-color: rgba(0,0,0,.12) !important;
}
.warranty-link{
  color: #1F1F1F;
}
.more {
  justify-content: center;
  min-height: 3rem;
  cursor: pointer;
}
.view-more {
  color: #3C4043FF;
  font-size: 0.875rem;
  font-weight: 500;
  text-align: center;
}
</style>
